import { render, staticRenderFns } from "./TravelNotesSwiper.vue?vue&type=template&id=02db8ed4&scoped=true"
import script from "./TravelNotesSwiper.vue?vue&type=script&lang=js"
export * from "./TravelNotesSwiper.vue?vue&type=script&lang=js"
import style0 from "./TravelNotesSwiper.vue?vue&type=style&index=0&id=02db8ed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02db8ed4",
  null
  
)

export default component.exports